<template>
  <div class="resend-method-wrapper">
    <p class="resend-method-title">
      Escolha por qual meio quer receber o código de verificação
    </p>

    <a class="resend-method" @click="() => resendUsingConfirmationType('SMS')">
      <div class="icon">
        <ChatAltIcon />
      </div>
      <div class="content">
        <p class="title">SMS</p>
        <p class="subtitle">
          No celular {{ phone | phoneMask({ lastDigits: true }) }}
        </p>
      </div>
      <ChevronRightIcon class="arrow" />
    </a>

    <a class="resend-method last" @click="() => resendUsingConfirmationType('WHATSAPP')">
      <div class="icon">
        <img src="https://cdn.parcelex.com.br/assets/v3/icons/rounded-whatsapp.svg">
      </div>
      <div class="content">
        <p class="title">Whatsapp</p>
        <p class="subtitle">
          No celular {{ phone | phoneMask({ lastDigits: true }) }}
        </p>
      </div>
      <ChevronRightIcon class="arrow" />
    </a>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex';
import { ChatAltIcon } from '@vue-hero-icons/outline';
import { ChevronRightIcon } from '@vue-hero-icons/solid';
import StringMixing from '@/mixins/string';
import UtilMixin from '@/mixins/util';

export default {
  name: 'resend-confirmation-options',
  mixins: [StringMixing, UtilMixin],
  components: {
    ChatAltIcon,
    ChevronRightIcon,
  },
  computed: {
    ...mapState('onboarding', [
      'phone',
      'type',
      'disableTheResendCounter',
    ]),
  },
  methods: {
    ...mapActions('onboarding', [
      'resendConfirmation',
      'resendCodeAndRedirect',
      'resendCodeAndRedirect',
      'setShowResendOptions',
    ]),
    ...mapMutations('onboarding', [
      'setChosenConfirmationResendType',
      'setResendConfirmationType',
    ]),
    resendUsingConfirmationType(resendType) {
      this.setResendConfirmationType(resendType);
      this.setChosenConfirmationResendType();
      this.resendConfirmation();
      this.setShowResendOptions({ showResendOptions: false });
    },
  },
};

</script>

<style lang="scss" scoped>
  @import '../../../scss/__new-styles.scss';

  .resend-method-wrapper {
    padding: 0px 24px;
  }

  .resend-method-title {
    font-family: 'Usual';
    font-size: 20px;
    line-height: 28px;
    color: var(--gray-900);
    margin: 20px 0 24px 0;
  }

  .resend-method {
    display: flex;
    gap: 12px;
    padding: 16px 0 16px 0;
    cursor: pointer;

    &.last {
      border-top: 1px solid var(--gray-200);
    }
  }

  .resend-method .icon {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 36px;
    height: 36px;
    background-color: var(--gray-200);
    color: var(--gray-500);
    border-radius: 50%;
  }

  .resend-method .content {
    flex: 1;
  }

  .resend-method .title {
    @extend .body-semi-bold;
    color: var(--gray-900);
    font-size: 16px;
    line-height: 24px;
  }

  .resend-method .subtitle {
    @extend .small-regular;
    color: var(--gray-500);
    font-size: 14px;
    line-height: 24px;
  }

  .resend-method .arrow {
    align-self: center;
    color: var(--gray-900);
  }

  .resend-code {
    font-size: 14px;
    line-height: 20px;
    text-align: center;
    color: #36A3CA;
    margin-top: 24px;
    margin-bottom: 36px;
  }

  .option-title > img, > svg {
    margin: unset;
  }

  @media (min-width: $lg) {
    .resend-method-wrapper {
      padding: 0px;
    }

    .resend-method-title {
      font-size: 16px;
      line-height: 24px;
      margin-bottom: 36px;
    }

    .resend-method {
      border: 1px solid var(--gray-200);
      border-radius: 8px;
      padding: 16px;

      &.last {
        margin-top: 12px;
      }
    }
  }
</style>
